import { render, staticRenderFns } from "./ResearchAdvisor.vue?vue&type=template&id=e09fabc8&"
import script from "./ResearchAdvisor.vue?vue&type=script&lang=js&"
export * from "./ResearchAdvisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports